package com.wintermar.inspection.core.ui.widget

import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import com.wintermar.inspection.core.ui.component.TextBodyRegular
import com.wintermar.inspection.core.ui.component.button.IconButton
import com.wintermar.inspection.core.ui.theme.LocalAppTheme
import inspection.composeapp.generated.resources.Res
import inspection.composeapp.generated.resources.ic_arrow_left
import inspection.composeapp.generated.resources.ic_arrow_right

@Composable
fun Pagination(
    page: Int,
    pageSize: Int,
    total: Int,
    modifier: Modifier = Modifier,
    onPrevious: () -> Unit,
    onNext: () -> Unit,
    content: @Composable () -> Unit,
) {
    val startItem = if (total == 0) 0 else ((page - 1) * pageSize) + 1
    val endItem = minOf(page * pageSize, total)
    val canGoPrevious = page > 1
    val canGoNext = endItem < total

    Column(
        modifier = modifier
    ) {
        Box(
            modifier = Modifier.weight(1f)
        ) {
            content()
        }
        Row(
            modifier = Modifier.fillMaxWidth()
                .padding(LocalAppTheme.current.dimension.spacing.space4),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(
                space = LocalAppTheme.current.dimension.spacing.space2,
                alignment = Alignment.End
            )
        ) {
            IconButton(
                icon = Res.drawable.ic_arrow_left,
                backgroundColor = Color.Transparent,
                tint = LocalAppTheme.current.color.icon.default,
                enabled = canGoPrevious,
                onClick = onPrevious
            )

            TextBodyRegular("$startItem - $endItem of $total")

            IconButton(
                icon = Res.drawable.ic_arrow_right,
                backgroundColor = Color.Transparent,
                tint = LocalAppTheme.current.color.icon.default,
                enabled = canGoNext,
                onClick = onNext
            )
        }
    }
}
